import { TagIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Brand = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TagIcon {...rest} width={Sizes[size]} color={fill} />;
};

Brand.displayName = 'Brand';
